import { Component, Input, OnInit } from '@angular/core';
import { AdComponent } from '../ad.component';
import { MaskPipe, MaskApplierService } from 'ngx-mask';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ViewService } from '../../view/view.service';

@Component({
  selector: 'person-card',
  templateUrl: './person-card.component.html',
  styleUrls: ['./person-card.component.scss']
})
export class PersonCardComponent extends AdComponent implements OnInit {

  owner:any = {};
  requestType:any = {};
  @Input() isCard: any = true;

  constructor(
    protected ms : MaskApplierService,
    protected srs : AdSearchService,
    protected gs : GeneralService,
    vs : ViewService){

    super(srs, gs, vs);
    this.srs.setFilterGroup('person');
    this.requestType = this.gs.getRequestTypes();
  }

  ngOnInit(){
    
    if(this.template=='ad')
      this.template = '_ad';

    const mask = new MaskPipe(this.ms);
    this.owner = this.data?.owner || this.data;

    if(typeof this.owner === 'undefined')
      return;
    

    if(this.owner?.site?.length > 6  && this.owner?.site?.indexOf('http') == -1)
      this.owner.site = 'http://'+this.owner.site;
    
    if(this.owner?.avatar){
      this.owner.avatar = this.gs.adjustAvatarFiles(this.owner);
      this.owner.avatarImg = this.getOwner('image');
    }

    if(this.owner?.logo){
      this.owner.logo = this.gs.adjustAvatarFiles(this.owner, 'logo');
      this.owner.logoImg = this.gs.getAvatarFile(this.owner.logo);
    }

    if(this.data?.adId && this.data?.phone){
      this.owner.phoneAdd = {
        phone : this.data.phone,
        phonemask : mask.transform(this.data.phone, this.gs.getPhoneMask(this.data.phone)),
        whatsapp : this.data.phoneWhatsapp,
        replace : this.data.phoneReplace
      }
    }
    this.owner.follow = this.getFollow('person');

    let firstpub = this.owner?.firstPublish? this.owner?.firstPublish?.substring(0,19).replace(' ','T') : false;
    this.owner._new = firstpub? this.gs.calculateDiff(firstpub) <= 10 : false;

    this.owner.viewAddress = this.getAddress('ad-view-person',true);
    this.owner.addressText = this.getAddress('',true);
    this.owner.addressDescription = this.getAddress('description',true);

    if(this.owner?.phone)
      this.owner.phonemask = mask.transform(this.owner.phone, this.gs.getPhoneMask(this.owner.phone));

    if(this.owner?.cellphone)
      this.owner.cellphonemask = mask.transform(this.owner.cellphone, this.gs.getPhoneMask(this.owner.cellphone));
      
    this.owner.phone_whatsapp = this.owner?.phone_whatsapp == '1';

    this.loading = false;

    //console.log(this.template, this.owner);
  }

  setDefaultCard(){

  }

}
  